import {Injectable} from '@angular/core';

@Injectable()
export class HamburgerService {

    public hamburgerOpen = false;

    constructor() { }

  openHamburger() {
    this.hamburgerOpen = true;
  }

  closeHamburger() {
    this.hamburgerOpen = false;
  }

}
